<template>
  <div class="card supplier-compete-detail-component">
    <div class="floating-operation-box">
      <slot></slot>
    </div>

    <h2 class="project-name">
      {{ order.competitionName }}
    </h2>

    <!--      竞价概况-->
    <div class="section">
      <base-section-title title="竞价概况" class="section-title" />
      <el-row class="section-content">
        <el-col :xs="24" :sm="24" :md="20" :lg="14" :xl="10">
          <el-form label-width="120px" class="detail-form" label-suffix="：">
            <el-form-item label="竞价单位">
              <span>{{ orderMes.purchaseCompanyName }}</span>
            </el-form-item>
            <el-form-item label="竞价编号">
              <span>{{ order.competitionCode }}</span>
            </el-form-item>
            <el-form-item label="项目类型">
              <span>{{
                projectTypeDict.translate(order.projectType).label
              }}</span>
            </el-form-item>
            <el-form-item label="响应截止时间">
              <span>{{ order.signUpEndTime | getNormMinuteFilter }}</span>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </div>

    <!--      品目信息-->
    <div class="section">
      <base-section-title class="section-title" title="品目信息" />

      <material-table
        :table-data="orderMes.materielList"
        :can-edit="false"
        :is-supplier="true"
        class="section-content"
      />
    </div>

    <!--      对供应商要求-->
    <div class="section">
      <base-section-title class="section-title" title="对供应商要求" />
      <el-row class="section-content">
        <el-col :xs="24" :sm="24" :md="20" :lg="14" :xl="10">
          <el-form label-width="120px" label-suffix="：" class="detail-form">
            <el-form-item label="报价要求">
              <span>{{
                Number(order.whetherTax) ? '报价含税' : '报价不含税'
              }}</span>
            </el-form-item>
            <el-form-item label="平台使用费">
              <span>{{ strToThousands(order.signUpFee) }} 元</span>
              <money-in-cn class="m-l-10" :money="order.signUpFee" />
            </el-form-item>
            <el-form-item label="保证金">
              <span>{{ strToThousands(order.deposit) }} 元</span>
              <money-in-cn class="m-l-10" :money="order.deposit" />
            </el-form-item>
            <el-form-item label="平台服务费">
              <el-button
                v-if="serviceInfo.chargeType === chargeTypeDict.CHARGE.value"
                type="text"
                style="padding: 0"
                @click="openConfigDialog()"
              >费用计算公式</el-button>
              <div
                v-else-if="serviceInfo.chargeType === chargeTypeDict.FREE.value"
              >
                <span> 0 元 </span>
                <money-in-cn money="0" />
              </div>
              <div v-else>-</div>
            </el-form-item>
            <el-form-item label="附件">
              <upload
                v-if="order.prAttachmentGroupId"
                :props-data="{
                  groupIdBefore: order.prAttachmentGroupId,
                  disabled: true
                }"
              />
              <span v-else>-</span>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </div>

    <!--      竞价规则-->
    <div class="section">
      <base-section-title class="section-title" title="竞价规则" />
      <el-row class="section-content">
        <el-col :xs="24" :sm="24" :md="20" :lg="14" :xl="10">
          <el-form label-width="120px" label-suffix="：" class="detail-form">
            <el-form-item label="竞价开始时间">
              <span>{{ order.competitionStartTime | getNormMinuteFilter }}</span>
            </el-form-item>
            <el-form-item label="竞价时长">
              <span>{{ order.competitionTime }} 分钟</span>
            </el-form-item>
            <el-form-item label="超时竞价延长">
              <span>{{ order.extendTime }} 分钟</span>
            </el-form-item>
            <el-form-item label="报价最小幅度">
              <span>{{ strToThousands(order.offerRange) }} 元</span>
              <money-in-cn :money="order.offerRange" />
            </el-form-item>
            <el-form-item label="报价次数">
              <span>无限制</span>
            </el-form-item>
            <el-form-item label="竞价过程">
              <span>{{
                Number(order.whetherOpen) ? '公开竞价公司' : '不公开竞价公司'
              }}</span>
            </el-form-item>
            <el-form-item label="竞价方式">
              <span>{{
                Number(order.competitionMethod) ? '竞高价' : '竞低价'
              }}</span>
            </el-form-item>
            <el-form-item label="起始价">
              <span>{{ strToThousands(order.competitionStart) }} 元</span>
              <money-in-cn :money="order.competitionStart" />
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </div>

    <!--      备注说明-->
    <div class="section">
      <base-section-title class="section-title" title="备注说明" />
      <el-row class="section-content">
        <el-col :xs="24" :sm="24" :md="20" :lg="14" :xl="10">
          <div class="order-tip-content">{{ order.remarks || '-' }}</div>
        </el-col>
      </el-row>
    </div>

    <!--      竞价须知-->
    <div class="section">
      <base-section-title class="section-title" title="竞价须知" />
      <el-row class="section-content">
        <el-col :xs="24" :sm="24" :md="20" :lg="14" :xl="10">
          <compete-copywriter type="prerequisites" />
        </el-col>
      </el-row>
    </div>

    <!--      注意事项-->
    <div class="section">
      <base-section-title class="section-title" title="注意事项" />
      <el-row class="section-content">
        <el-col :xs="24" :sm="24" :md="20" :lg="14" :xl="10">
          <compete-copywriter type="caveat" />
        </el-col>
      </el-row>
    </div>

    <!--    公告-->
    <div class="section">
      <base-section-title
        class="section-title"
        :title="announcementInvitation"
      />
      <div class="section-content notice-content">
        <h4>{{ purchaseNotice.noticeTitle }}</h4>
        <u-editor :value="purchaseNotice.noticeContent" :disabled="true" />
      </div>
    </div>

    <!----计算公式详情--->
    <charge-config-dialog
      ref="chargeConfigDialog"
      :config-obj="{
        configId: serviceInfo.configId,
        templateId: serviceInfo.templateId
      }"
    />
  </div>
</template>

<script>
// 组件
import MaterialTable from '@/components/compete/Material/MaterialTable'
import BaseSectionTitle from '@/components/common/BaseSectionTitle'
import Upload from '@/components/common/Upload'
import UEditor from '@/components/common/UEditor/index.vue'
import CompeteCopywriter from '@/components/copywriter/CompeteCopywriter'
import MoneyInCn from '@/components/common/MoneyInCn'
import ChargeConfigDialog from '@/components/common/ChargeConfigDialog'

// 数据字典
import { projectTypeDict } from '@/dictionary/project/common'
import { costSubjectDict, chargeTypeDict } from '@/dictionary/company'

// 工具方法
import { strToThousands } from '@/utils/utils'

export default {
  name: 'SupplierCompeteDetailComponent',

  components: {
    MaterialTable,
    BaseSectionTitle,
    Upload,
    UEditor,
    CompeteCopywriter,
    MoneyInCn,
    ChargeConfigDialog
  },

  props: {
    orderMes: {
      type: Object,
      required: true
    },
    // 叫公告还是邀请函
    announcementInvitation: {
      type: String,
      default: '公告内容'
    }
  },

  data() {
    return {
      projectTypeDict,
      chargeTypeDict
    }
  },

  computed: {
    // 将orderMes中的对象字段进行兜底
    order() {
      return this.orderMes.order || {}
    },
    purchaseNotice() {
      return this.orderMes.purchaseNotice || {}
    },
    serviceInfo() {
      const obj =
        (this.orderMes.chargeList || []).find(
          m => m.costSubject === costSubjectDict.SERVICE_FEE.value
        ) || {}
      return obj
    }
  },

  methods: {
    strToThousands,

    /**
     * 打开平台服务费配置
     */
    openConfigDialog() {
      this.$refs.chargeConfigDialog.open()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/variable.scss';

.supplier-compete-detail-component {
  position: relative;

  .floating-operation-box {
    position: absolute;
    right: 0;
    top: pixel-to-rem($n: 140);
    z-index: 1;
  }
}

.order-tip-content {
  font-size: pixel-to-rem($n: 20);

  p {
    margin: 0;
    line-height: 1.5;
  }
}

.project-name {
  text-align: center;
  font-size: pixel-to-rem($n: 26);
  @include text-bold;
  line-height: 1.5;
  padding: pixel-to-rem(20);
  padding-top: 0;
  border-bottom: 1px solid $border-color;
  margin-bottom: pixel-to-rem($n: 20);
}

// 公告内容样式
.notice-content {
  h4 {
    font-size: pixel-to-rem($n: 20);
  }
}
</style>
